(()=>{
    function initCarousel(root) {
        const track = root.querySelector('[data-carousel-track]');
        const prev = root.querySelector('[data-carousel-prev]');
        const next = root.querySelector('[data-carousel-next]');
        const indicator = root.querySelector('[data-carousel-indicator]');
        if (!track || !prev || !next || !indicator) return;
        const items = Array.from(track.querySelectorAll('[data-carousel-item]'));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let current = 0;
        function updateAccessibility() {
            const carouselControlsVisible = getComputedStyle(prev.parentElement).display !== 'none';
            items.forEach((item, itemIndex)=>{
                const inactive = carouselControlsVisible && itemIndex !== current;
                item.toggleAttribute('inert', inactive);
                if (inactive) item.setAttribute('aria-hidden', 'true');
                else item.removeAttribute('aria-hidden');
            });
        }
        function updateState(index) {
            current = index;
            indicator.textContent = `${current + 1} / ${items.length}`;
            prev.disabled = current === 0;
            next.disabled = current === items.length - 1;
            items.forEach((item, itemIndex)=>item.classList.toggle('is-active', itemIndex === current));
            updateAccessibility();
        }
        function goTo(index, animate = true) {
            const nextIndex = Math.max(0, Math.min(index, items.length - 1));
            updateState(nextIndex);
            track.scrollTo({
                left: items[nextIndex].offsetLeft - track.offsetLeft,
                behavior: animate && !reduceMotion.matches ? 'smooth' : 'auto'
            });
        }
        prev.addEventListener('click', ()=>goTo(current - 1));
        next.addEventListener('click', ()=>goTo(current + 1));
        track.addEventListener('scroll', ()=>{
            let closest = 0;
            let minimumDistance = Infinity;
            items.forEach((item, index)=>{
                const distance = Math.abs(item.offsetLeft - track.offsetLeft - track.scrollLeft);
                if (distance < minimumDistance) {
                    minimumDistance = distance;
                    closest = index;
                }
            });
            if (closest !== current) updateState(closest);
        });
        window.addEventListener('resize', updateAccessibility);
        goTo(0, false);
    }
    function init() {
        document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();

//# sourceMappingURL=carousel.1b5c6de5.js.map
